import { Component, EventEmitter, Input, Output } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { GenericResponseDto } from "../../../core/models/generic-response.dto";
import { getBase64 } from "../../../core/services/shared.service";
import { FileType } from "../../enums/fileType";
import { CommonModule } from "@angular/common";
import { FileData } from "../../../core/models/file-data.model";
import { AddNewClientService } from "../../../core/services/add-new-client.service";
import { FileUploadDto } from "../../../core/models/shared/fileUploadDto";
import { ClientAttachment } from "../../../core/models/client/details/clientAttachment";
import {
  GlobalFileDragDropDirective,
  DroppedFile,
} from "../../directives/global-file-drag-drop.directive";
import { GlobalFileUploadService } from "../../services/global-file-upload.service";

@Component({
  selector: "jni-attachment",
  standalone: true,
  imports: [CommonModule, GlobalFileDragDropDirective],
  templateUrl: "./attachment.component.html",
  styleUrls: [
    "./attachment.component.scss",
    "../../directives/global-file-drag-drop.styles.scss",
  ],
})
export class AttachmentComponent {
  fileAttachment: ClientAttachment[] = [];
  attachmentFileName = "";
  attachmentValidationMessage = false;
  attachmentRemove = false;
  attachmentFileSize = false;
  fileObject: FileUploadDto[] = [];
  fileSizeInKb = 1024;
  @Input()
  attachmentLabel!: string;
  @Input()
  fileName!: string;
  fileUrl?: GenericResponseDto<string>;
  files?: FileData;
  @Output() attachmentFileEvent = new EventEmitter<ClientAttachment[]>();

  constructor(
    private _addNewClientService: AddNewClientService,
    private _globalFileUploadService: GlobalFileUploadService
  ) {}
  async getAttachmentFile(file: Event): Promise<void> {
    this.fileAttachment = [];
    this.files = {} as FileData;
    this.fileObject = [];
    const inputElement = file.target as HTMLInputElement;
    const fileObj = inputElement.files?.[0];

    if (!fileObj) {
      return;
    }

    const filesize = Math.round(fileObj.size / this.fileSizeInKb);
    if (filesize <= this.fileSizeInKb) {
      this.attachmentFileName = fileObj.name;
      const fileextension = "." + fileObj.name.split(".").pop()?.toLowerCase();
      await getBase64(fileObj).then(data => {
        const base64Data = data as string;
        this.createAttachmentFileObject(
          this.fileName,
          FileType.url,
          base64Data
        );
        this.createFileUploadDto(
          base64Data,
          this.fileName,
          fileextension || "",
          filesize,
          fileObj.type
        );
      });
      this.attachmentValidationMessage = false;
      this.attachmentRemove = true;
      this.attachmentFileSize = false;
    } else {
      this.attachmentFileSize = true;
    }

    await this.getAttachmentUrlData(this.fileObject);
    this.fileAttachment.map(obj => {
      if (obj.descriptionD365 == this.fileName) {
        obj.notesD365 = this.files?.file;
        this.attachmentFileEvent.emit(this.fileAttachment);
      }
    });
  }

  async getAttachmentUrlData(attachment: FileUploadDto[]) {
    const attachmentObj = attachment.filter(x => x.fileName == this.fileName);

    if (attachmentObj.length > 0) {
      this.fileUrl = await lastValueFrom(
        this._addNewClientService.getRescaleAttachmentUrl(attachmentObj)
      );
    }

    this.files = {
      file: this.fileUrl != undefined ? this.fileUrl.data : "",
    };
  }

  createAttachmentFileObject(name: string, extension: string, data: string) {
    this.fileAttachment.push({
      typeIdD365: extension,
      notesD365: data,
      restrictionD365: 1,
      descriptionD365: name,
      // createdDate: "",
      // createdBy: "",
      // lastModifiedDate: null,
      // lastModifiedBy: null,
      // isActive: false,
    });
  }

  createFileUploadDto(
    data: string,
    name: string,
    extension: string,
    size: number,
    filemimetype: string
  ) {
    const base64File = data.split(",")[1];
    this.fileObject.push({
      base64: base64File,
      fileName: name,
      fileExtension: extension,
      fileSize: size,
      fileMimeType: filemimetype,
    });
  }

  // Global drag-and-drop handlers
  onAttachmentDropped(droppedFiles: DroppedFile[]): void {
    if (droppedFiles.length > 0) {
      const file = droppedFiles[0];

      // Create mock event to work with existing method
      const mockEvent = {
        target: { files: [file.file] },
      } as unknown as Event;

      this.getAttachmentFile(mockEvent);
    }
  }

  onFilesRejected(rejectedFiles: { file: File; reason: string }[]): void {
    this._globalFileUploadService.handleRejectedFiles(rejectedFiles);
  }
}
